
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/148a04923324ce7ea4541ee2b258f08e.jpg"
          alt="Cadence Studios - Innovating across film entertainment and tech"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <h1
          className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] mb-8 tracking-tight"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Innovating across<br />
          <span className="italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            film, entertainment
          </span>
          <br />
          and tech
        </h1>

        <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed font-light">
          Cadence Studios is a creative powerhouse at the intersection of storytelling, technology,
          and culture.
        </p>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-3xl text-white/50"></i>
      </div>
    </section>
  );
}
